import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

interface EditButtonProps {
  disabled?: boolean;
  label?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function EditButton({
  disabled,
  label = "Bearbeiten",
  onClick
}: EditButtonProps) {
  return (
    <Tooltip label={label}>
      <ActionIcon
        aria-label={label}
        color="darkblue"
        disabled={disabled}
        size="xs"
        variant="transparent"
        onClick={onClick}
      >
        <IconEdit className="edit-icon" data-testid="icon-button-edit" />
      </ActionIcon>
    </Tooltip>
  );
}

export { EditButton, EditButtonProps };
